export default class ComboVariableClassModel {

    idNTipoVariableCombo: number | null;
    fkNTipoVariable: number | null;
    fldTCombo: string | null;
    fldNValor: number | null;
    fldNOrden: number | null;


    constructor(model: any) {
        this.idNTipoVariableCombo = null;
        this.fkNTipoVariable = null;
        this.fldTCombo = null;
        this.fldNOrden = null;
        this.fldNValor = null;

        Object.assign(this, model);
    }
}